// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"231":"homeTrivia","268":"Home","483":"Question","683":"Auth Layout","712":"EndGame"}[chunkId] + "." + {"231":"c0a64cd5","268":"a0561dfc","483":"9b644e1d","683":"65155d56","712":"8c617185"}[chunkId] + ".css";
};